import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isGranted('DELETE_USER', _ctx.user))
    ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
        key: 0,
        icon: "fa fa-times",
        title: "Delete user"
      }, _ctx.$attrs, { onClick: _ctx.openModal }), null, 16, ["onClick"]))
    : _createCommentVNode("", true)
}